import * as angular from 'angular';

class AnalyticsFilterComponent {
    public filer: {};
    public breakdowns: string[];
    public dateOptions = {
        formatYear: 'yyyy',
        startingDay: 0
    };
}

angular.module('naut').component('analyticsFilter', {
    template: require('./analyticsFilter.html'),
    controller: AnalyticsFilterComponent,
    controllerAs: 'vm',
    bindings: {
        filter: '=',
        breakdowns: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/components/analyticsFilter/analyticsFilter.component.ts